import React from "react";
import { ShieldAlert } from "lucide-react";

export const WarningSection = ({ warnings = [], disclaimer = "", criticalWarning = "" }) => {
    if (!warnings.length && !disclaimer && !criticalWarning) return null;
    return (
        <div className="text-zinc-400" data-testid="warning-section">
            {criticalWarning && (
                <div className="flex items-start gap-3 border border-red-500/40 bg-red-500/[0.07] px-4 py-3.5 mb-5">
                    <ShieldAlert className="w-4 h-4 text-red-400 mt-0.5 shrink-0" />
                    <span className="text-sm uppercase tracking-[0.12em] font-bold text-red-300">{criticalWarning}</span>
                </div>
            )}
            <ul className="space-y-3">
                {warnings.map((w, i) => (
                    <li key={i} className="flex gap-3 text-sm leading-relaxed">
                        <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2 shrink-0" />
                        <span>{w}</span>
                    </li>
                ))}
            </ul>
            {disclaimer && (
                <p className="mt-5 pt-5 border-t border-white/10 text-xs text-zinc-500 leading-relaxed">{disclaimer}</p>
            )}
        </div>
    );
};

export default WarningSection;
